import React from 'react';

import styled from 'styled-components';

const Steps = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const Step = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid var(--white-60);
  border-radius: 30px;
  background-image: linear-gradient(102deg, rgba(255, 255, 255, 0.4) 28%, rgba(255, 255, 255, 0.24) 75%);
  font-family: var(--font-bold);
`;

const StepNumber = styled.span`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--flamingo-pink);
`;

type Props = {
  steps: string[];
};

const ComingSoonSteps = ({ steps }: Props) => (
  <Steps>
    {steps.map((step, index) => (
      <Step key={step}>
        <StepNumber>{index + 1}</StepNumber>
        {step}
      </Step>
    ))}
  </Steps>
);

export default ComingSoonSteps;
